import { ProcessingStatus } from 'enums';
import { FileInInspectionType, FileType } from 'state';

type InspectionStatusType = {
  complete: number;
  processing: number;
  errored: number;
  total: number;
  message: string;
};

export const getInspectionStatus = (
  inspectionFiles: FileInInspectionType | FileType[],
  isLoaded: boolean,
): InspectionStatusType => {
  const status = {
    complete: 0,
    processing: 0,
    errored: 0,
    total: 0,
    message: 'No files',
  };

  if (!isLoaded) {
    status.message = 'Loading...';

    return status;
  }

  if (!inspectionFiles) return status;

  const files = Array.isArray(inspectionFiles)
    ? inspectionFiles
    : Object.keys(inspectionFiles)
        .map(k => inspectionFiles[k])
        .reduce((c, n) => c.concat(n), []);

  if (files.length === 0) return status;

  status.total = files.length;

  status.complete = files.filter(
    f =>
      (f.processingStatus === ProcessingStatus.PROCESSED ||
        f.processingStatus === ProcessingStatus.ERRORED) &&
      f.uploadCompleted,
  ).length;

  status.errored = files.filter(
    f => f.processingStatus === ProcessingStatus.ERRORED && f.uploadCompleted,
  ).length;

  status.processing = status.total - status.complete;

  status.message =
    status.complete === status.total
      ? 'Ready'
      : `${status.complete} / ${status.total} files ready`;

  return status;
};
